import { OtherDocListComponent } from "../application/OtherDocListComponent.ts";
import { ApiOtherDocumentRepository } from "./ApiOtherDocumentRepository";
import { ApiWorkflowTemplateRepository } from "./ApiWorkflowTemplateRepository";
import { VueOtherDocumentListScreenData } from "./VueOtherDocumentListScreenData";
import { EntitiesListComponent } from "@/modules/entities/app/EntitiesListComponent.ts";
import { EntityTypeApiRepository ,EntityInstanceApiRepository} from "@/modules/entities/infra/EntitiesApiRepositories.ts";
import {EntitiesListScreenData} from "@/modules/entities/domain/EntitiesListScreenData.ts";
export class DocumentComponentsFactory {
    list_component: any;
    entities_list_component: any;

    constructor() {
        this.list_component = null;
        this.entities_list_component = null;
    }

    get_or_create_list_component() {
        if (!this.list_component) {
            this.list_component = new OtherDocListComponent(new ApiOtherDocumentRepository(), new VueOtherDocumentListScreenData(), new ApiWorkflowTemplateRepository());
        }
        return this.list_component;
    }

    get_list_component() {
        return this.list_component;
    }

    get_or_create_entities_list_component() {
        if (!this.entities_list_component) {
            this.entities_list_component = new EntitiesListComponent(new EntityTypeApiRepository(),new EntityInstanceApiRepository(), new EntitiesListScreenData());
        }
        return this.entities_list_component;
    }
}
